import React from "react";
import styled from "styled-components";
import { Card } from "../router/main/component/Card";
import { findTest } from "../data/data";
import { findProducts } from "../data/products";

/** 결과 아래 '이어서 해볼 것' — 다른 테스트 카드 + 상품·강의 링크 */
export const Recommendations = ({ recommend }) => {
  if (!recommend) return null;
  const tests = (recommend.tests || []).map(findTest).filter(Boolean);
  const items = findProducts(recommend.products);
  if (!tests.length && !items.length) return null;

  return (
    <Wrap>
      {items.length > 0 && (
        <>
          <Heading>이 결과에 도움이 될 것들</Heading>
          <List>
            {items.map((p) => (
              <Product key={p.id} href={p.url} target="_blank" rel="noopener noreferrer">
                <Label>{p.label}</Label>
                <div>
                  <strong>{p.title}</strong>
                  <span>{p.desc}</span>
                </div>
                <Arrow aria-hidden="true">→</Arrow>
              </Product>
            ))}
          </List>
          {items.some((p) => p.coupang) && (
            <Disclosure>
              이 페이지의 쿠팡 링크는 쿠팡 파트너스 활동의 일환으로, 이에 따른 일정액의 수수료를 제공받습니다.
            </Disclosure>
          )}
        </>
      )}
      {tests.length > 0 && (
        <>
          <Heading>이어서 해보면 좋은 테스트</Heading>
          <List>
            {tests.map((t) => (
              <Card key={t.id} cardItem={t} />
            ))}
          </List>
        </>
      )}
    </Wrap>
  );
};

const Wrap = styled.section`
  width: 100%;
  margin-top: 8px;
  display: flex;
  flex-direction: column;
  gap: 14px;
`;

const Heading = styled.h3`
  margin-top: 20px;
  font-size: 17px;
  font-weight: 400;
`;

const List = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
`;

const Product = styled.a`
  display: grid;
  grid-template-columns: auto 1fr auto;
  gap: 12px;
  align-items: center;
  padding: 14px 16px;
  border: 1px solid #e3e3e3;
  border-radius: 14px;
  color: #1f2022;
  text-decoration: none;
  transition: background 0.2s ease;

  &:hover {
    background: #f6f6f6;
  }
  div > strong {
    display: block;
    font-size: 15px;
    font-weight: 400;
  }
  div > span {
    display: block;
    margin-top: 4px;
    font-size: 13px;
    color: #777;
  }
`;

const Label = styled.span`
  padding: 4px 8px;
  border-radius: 8px;
  font-size: 12px;
  color: #133337;
  background: #fadeac;
  white-space: nowrap;
`;

const Arrow = styled.span`
  font-size: 16px;
  color: #999;
`;

const Disclosure = styled.p`
  margin: 2px 2px 0;
  font-size: 11.5px;
  line-height: 1.5;
  color: #9a9a9a;
`;
